import BundleProduct from "../../../entities/manhattan/bundle/BundleProduct";
import { IBundleProduct, IBundleProductConfiguration } from "../../../entities/manhattan/bundle/types";
import { BundleProductConfigurationFactory } from "./BundleProductConfigurationFactory";

export default class BundleProductFactory {

  static create(bundleProduct: IBundleProduct): BundleProduct {
    return new BundleProduct(
      bundleProduct.id,
      bundleProduct.isMaster,
      bundleProduct.useOriginalPrices,
      this.createBundleProductConfigurations(bundleProduct.bundleProductConfigurations),
      bundleProduct.bundleProductPrices,
      bundleProduct.product
    );
  }

  private static createBundleProductConfigurations (bundleProductConfigurations: IBundleProductConfiguration[]) {
    const bundleProductConfigurationsTemp: IBundleProductConfiguration[] = [];
    bundleProductConfigurations.forEach((bundleProductConfiguration: IBundleProductConfiguration) => {
      bundleProductConfigurationsTemp.push(BundleProductConfigurationFactory.create(bundleProductConfiguration));
    });

    return bundleProductConfigurationsTemp;
  }

}
